var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "confirmation-form" },
    [
      _c(
        "panel-competition-form-box",
        { staticClass: "confirmation-form__box mab16" },
        [
          _c(
            "div",
            { staticClass: "col-12 col-lg-8" },
            [
              _c("panel-input-area", {
                ref: "messageArea",
                attrs: {
                  label: "Treść e-maila z potwierdzeniem rejestracji",
                  rows: 12,
                },
                model: {
                  value: _vm.content,
                  callback: function ($$v) {
                    _vm.content = $$v
                  },
                  expression: "content",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "col-12 col-lg-4" }, [
            _c(
              "div",
              { staticClass: "confirmation-form__container" },
              [
                _c(
                  "base-button",
                  {
                    staticClass: "confirmation-form__test",
                    attrs: {
                      btn2: "",
                      short: "",
                      icon: "fas fa-envelope",
                      loading: _vm.sendingTest,
                      disabled: _vm.saving || _vm.sendingTest,
                    },
                    on: { click: _vm.onSendTest },
                  },
                  [_vm._v(" Wyślij na własny adres ")]
                ),
                _c("p", { staticClass: "tags-title mat24" }, [
                  _vm._v("Znaczniki personalizacji"),
                ]),
                _c("p", { staticClass: "tags-desc" }, [
                  _vm._v("Kliknij znacznik, aby wstawić go do treści:"),
                ]),
                _c(
                  "ul",
                  { staticClass: "tags-list" },
                  _vm._l(_vm.availableTags, function (tag) {
                    return _c("li", { key: tag.key }, [
                      _c(
                        "button",
                        {
                          staticClass: "tag-btn",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.insertTag(tag.key)
                            },
                          },
                        },
                        [_vm._v("[" + _vm._s(tag.key) + "]")]
                      ),
                      _c("span", { staticClass: "tag-label" }, [
                        _vm._v(_vm._s(tag.label)),
                      ]),
                    ])
                  }),
                  0
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "confirmation-form__actions mat24 mab24" },
        [
          _c(
            "base-button",
            {
              attrs: {
                btn1: "",
                loading: _vm.saving,
                disabled: _vm.saving || _vm.sendingTest,
              },
              on: { click: _vm.onSave },
            },
            [_vm._v("Zapisz")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }